/**
 * ReadyButton Component
 *
 * Button for players to toggle ready status in lobby.
 * Displays current ready state and allows toggling.
 *
 * Used by:
 * - LobbyPhase
 *
 * Responsibilities:
 * - Toggle ready status on click
 * - Display current ready state
 * - Show enabled/disabled state based on conditions
 *
 * Dependencies: types/game.types.ts
 */

import React from 'react';

export interface ReadyButtonProps {
    /** Current ready status */
    isReady: boolean;
    /** Callback when ready status is toggled */
    onToggleReady: () => void;
    /** Whether button is disabled */
    isDisabled?: boolean;
    /** Optional className for styling */
    className?: string;
}

/**
 * ReadyButton Component
 */
export const ReadyButton: React.FC<ReadyButtonProps> = ({
    isReady,
    onToggleReady,
    isDisabled = false,
    className = 'lobby_bottom_button',
}) => {
    return (
        <button
            className={className}
            onClick={onToggleReady}
            disabled={isDisabled}
        >
            {isReady ? 'Unready' : 'Ready'}
        </button>
    );
};

export default ReadyButton;
